var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_category"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0937 0H17.3828C15.2283 0 13.4766 1.75171 13.4766 3.90625V7.61719C13.4766 9.77173 15.2283 11.5234 17.3828 11.5234H21.0937C23.2483 11.5234 25 9.77173 25 7.61719V3.90625C25 1.75171 23.2483 0 21.0937 0ZM23.0469 7.61719C23.0469 8.69141 22.168 9.57031 21.0937 9.57031H17.3828C16.3086 9.57031 15.4297 8.69141 15.4297 7.61719V3.90625C15.4297 2.83203 16.3086 1.95312 17.3828 1.95312H21.0937C22.168 1.95312 23.0469 2.83203 23.0469 3.90625V7.61719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.61719 0H3.90625C1.75171 0 0 1.75171 0 3.90625V7.61719C0 9.77173 1.75171 11.5234 3.90625 11.5234H7.61719C9.77173 11.5234 11.5234 9.77173 11.5234 7.61719V3.90625C11.5234 1.75171 9.77173 0 7.61719 0ZM9.57031 7.61719C9.57031 8.69141 8.69141 9.57031 7.61719 9.57031H3.90625C2.83203 9.57031 1.95312 8.69141 1.95312 7.61719V3.90625C1.95312 2.83203 2.83203 1.95312 3.90625 1.95312H7.61719C8.69141 1.95312 9.57031 2.83203 9.57031 3.90625V7.61719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.61719 13.4766H3.90625C1.75171 13.4766 0 15.2283 0 17.3828V21.0937C0 23.2483 1.75171 25 3.90625 25H7.61719C9.77173 25 11.5234 23.2483 11.5234 21.0937V17.3828C11.5234 15.2283 9.77173 13.4766 7.61719 13.4766ZM9.57031 21.0937C9.57031 22.168 8.69141 23.0469 7.61719 23.0469H3.90625C2.83203 23.0469 1.95312 22.168 1.95312 21.0937V17.3828C1.95312 16.3086 2.83203 15.4297 3.90625 15.4297H7.61719C8.69141 15.4297 9.57031 16.3086 9.57031 17.3828V21.0937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.0234 20.1172C23.4863 20.1172 23.0469 20.5566 23.0469 21.0937C23.0469 22.168 22.168 23.0469 21.0938 23.0469H17.3828C16.3086 23.0469 15.4297 22.168 15.4297 21.0937V17.3828C15.4297 16.3086 16.3086 15.4297 17.3828 15.4297H21.0938C21.8689 15.4297 22.5708 15.8874 22.8821 16.6016C23.0957 17.0959 23.6755 17.3218 24.1699 17.102C24.6643 16.8884 24.8901 16.3086 24.6704 15.8142C24.0479 14.3921 22.644 13.4705 21.0876 13.4705H17.3767C15.2222 13.4705 13.4705 15.2222 13.4705 17.3767V21.0876C13.4705 23.2422 15.2222 24.9939 17.3767 24.9939H21.0876C23.2422 24.9939 24.9939 23.2422 24.9939 21.0876C25 20.5566 24.5605 20.1172 24.0234 20.1172Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCategory);
export default __webpack_public_path__ + "static/media/nav_category.d31069bb6970f4901f327be02dd54ec7.svg";
export { ForwardRef as ReactComponent };